export default __webpack_public_path__ + "media/images/home/slide_silver_week_2026_lg-f1f17e2133b5c49244eb786b07c3bed2.jpg";